// Analytics module
import { isDevelopment } from '../utils/environment';

export async function initAnalytics() {
  // Initialize tracking
  const userId = getOrCreateUserId();

  // Track session start
  track('session_start', {
    user_id: userId,
    timestamp: new Date().toISOString(),
    url: window.location.href,
    referrer: document.referrer,
    user_agent: navigator.userAgent,
    screen_size: `${window.screen.width}x${window.screen.height}`,
    viewport_size: `${window.innerWidth}x${window.innerHeight}`
  });

  // Track page visibility changes
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') {
      track('app_background');
    } else {
      track('app_foreground');
    }
  });

  return userId;
}

// Track event
export function track(eventName, properties = {}) {
  const event = {
    event: eventName,
    properties: {
      ...properties,
      timestamp: new Date().toISOString(),
      session_id: getSessionId()
    }
  };

  // Log to console in development
  if (isDevelopment()) {
    console.log('📊 Analytics:', event);
  }

  // Send to analytics service (implement based on your analytics provider)
  // Example: Meta Pixel
  if (window.fbq) {
    window.fbq('trackCustom', eventName, properties);
  }

  // Example: Custom endpoint
  sendToEndpoint(event);
}

// Send to analytics endpoint
async function sendToEndpoint(event) {
  try {
    // Batch events
    addToBatch(event);

    // Send batch after delay
    scheduleBatchSend();
  } catch (error) {
    console.error('Failed to track event:', error);
  }
}

// Event batching
let eventBatch = [];
let batchTimer = null;

function addToBatch(event) {
  eventBatch.push(event);

  // Send immediately if batch is large
  if (eventBatch.length >= 10) {
    sendBatch();
  }
}

function scheduleBatchSend() {
  if (batchTimer) return;

  batchTimer = setTimeout(() => {
    sendBatch();
    batchTimer = null;
  }, 2000); // Send after 2 seconds
}

async function sendBatch() {
  if (eventBatch.length === 0) return;

  const events = [...eventBatch];
  eventBatch = [];

  try {
    // Send to your analytics endpoint
    // await fetch('/api/analytics', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ events })
    // });
  } catch (error) {
    console.error('Failed to send analytics batch:', error);
    // Re-add events to batch for retry
    eventBatch.unshift(...events);
  }
}

// Get or create user ID
function getOrCreateUserId() {
  const key = 'lunai_analytics_user_id';
  let userId = localStorage.getItem(key);

  if (!userId) {
    userId = 'u_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem(key, userId);
  }

  return userId;
}

// Get or create session ID
function getSessionId() {
  const key = 'lunai_session_id';
  const sessionDuration = 30 * 60 * 1000; // 30 minutes

  let session = JSON.parse(sessionStorage.getItem(key) || 'null');
  const now = Date.now();

  if (!session || now - session.lastActivity > sessionDuration) {
    session = {
      id: 's_' + now + '_' + Math.random().toString(36).substr(2, 9),
      startTime: now,
      lastActivity: now
    };
  } else {
    session.lastActivity = now;
  }

  sessionStorage.setItem(key, JSON.stringify(session));
  return session.id;
}

// Track specific events
export function trackScreenView(screenName, properties = {}) {
  track('screen_view', {
    screen_name: screenName,
    ...properties
  });
}

export function trackButtonClick(buttonName, properties = {}) {
  track('button_click', {
    button_name: buttonName,
    ...properties
  });
}

export function trackFormSubmit(formName, properties = {}) {
  track('form_submit', {
    form_name: formName,
    ...properties
  });
}

export function trackCheckoutStart(properties = {}) {
  track('checkout_start', properties);
}

export function trackPurchase(properties = {}) {
  track('purchase', properties);
}

// Listen for analytics events from other modules
document.addEventListener('analytics:screen', (event) => {
  trackScreenView(event.detail.screen_name, event.detail);
});